
type Props = {
  className?: string;
}

export const SvgSWTriangleBar = ({ className }: Props) => {
  return (
    <svg
      width="32"
      height="400"
      viewBox="0 0 32 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.8544 367.507L31.7065 351.024H0.00100327L15.8544 367.507Z"
        fill="#99DAA2"
      />
      <path
        d="M31.7068 383.989L15.8547 367.507L-3.43323e-05 383.989H31.7068Z"
        fill="#4E4699"
      />
      <path
        d="M31.7068 383.989L31.7068 351.022L15.8547 367.507L31.7068 383.989Z"
        fill="#2F3289"
      />
      <path
        d="M0.00132561 351.024L15.8547 367.507L0.00132561 383.989L0.00132561 351.024Z"
        fill="#F57C14"
      />
      <path
        d="M15.8544 334.538L31.7065 318.056H0.00100327L15.8544 334.538Z"
        fill="#E6F7FD"
      />
      <path
        d="M31.707 351.025L15.8549 334.543L0.000209808 351.025H31.707Z"
        fill="#FFF64D"
      />
      <path
        d="M31.707 351.025L31.707 318.059L15.8549 334.543L31.707 351.025Z"
        fill="#FFF31A"
      />
      <path
        d="M0.00132561 318.059L15.8547 334.543L0.00132561 351.025L0.00132561 318.059Z"
        fill="#F9B3DD"
      />
      <path
        d="M15.8544 301.576L31.7065 285.093H0.00100327L15.8544 301.576Z"
        fill="#F6836C"
      />
      <path
        d="M31.707 318.058L15.8549 301.575L0.000209808 318.058H31.707Z"
        fill="#F57C14"
      />
      <path
        d="M31.707 318.058L31.707 285.093L15.8549 301.575L31.707 318.058Z"
        fill="#FBCCE8"
      />
      <path
        d="M0.00132561 285.09L15.8547 301.574L0.00132561 318.056L0.00132561 285.09Z"
        fill="#99DAA2"
      />
      <path
        d="M15.8544 268.609L31.7065 252.126H0.00100327L15.8544 268.609Z"
        fill="#FFF31A"
      />
      <path
        d="M31.707 285.092L15.8549 268.61L0.000209808 285.092H31.707Z"
        fill="#2F3289"
      />
      <path
        d="M31.707 285.092L31.707 252.125L15.8549 268.61L31.707 285.092Z"
        fill="#FFF880"
      />
      <path
        d="M0.00132561 252.126L15.8547 268.61L0.00132561 285.092L0.00132561 252.126Z"
        fill="#F89C35"
      />
      <path
        d="M15.8544 235.643L31.7065 219.161H0.00100327L15.8544 235.643Z"
        fill="#4E4699"
      />
      <path
        d="M31.707 252.127L15.8549 235.644L0.000209808 252.127H31.707Z"
        fill="#66C87F"
      />
      <path
        d="M31.707 252.127L31.707 219.162L15.8549 235.644L31.707 252.127Z"
        fill="#EF3120"
      />
      <path
        d="M0.00132561 219.162L15.8547 235.645L0.00132561 252.127L0.00132561 219.162Z"
        fill="#33B764"
      />
      <path
        d="M15.8544 202.678L31.7065 186.195H0.00100327L15.8544 202.678Z"
        fill="#7264AB"
      />
      <path
        d="M31.707 219.161L15.8549 202.677L0.000209808 219.161H31.707Z"
        fill="#F9B3DD"
      />
      <path
        d="M31.707 219.161L31.707 186.194L15.8549 202.677L31.707 219.161Z"
        fill="#FFF64D"
      />
      <path
        d="M0.00132561 186.195L15.8547 202.679L0.00132561 219.161L0.00132561 186.195Z"
        fill="#F6836C"
      />
      <path
        d="M15.8544 169.712L31.7065 153.228H0.00100327L15.8544 169.712Z"
        fill="#F6836C"
      />
      <path
        d="M31.707 186.194L15.8549 169.712L0.000209808 186.194H31.707Z"
        fill="#F9B3DD"
      />
      <path
        d="M31.707 186.194L31.707 153.227L15.8549 169.712L31.707 186.194Z"
        fill="#FBC961"
      />
      <path
        d="M0.00132561 153.229L15.8547 169.712L0.00132561 186.194L0.00132561 153.229Z"
        fill="#FBCCE8"
      />
      <path
        d="M15.8544 136.745L31.7065 120.263H0.00100327L15.8544 136.745Z"
        fill="#99DAA2"
      />
      <path
        d="M31.707 153.23L15.8549 136.748L0.000209808 153.23H31.707Z"
        fill="#99DAA2"
      />
      <path
        d="M31.707 153.23L31.707 120.264L15.8549 136.748L31.707 153.23Z"
        fill="#EF3120"
      />
      <path
        d="M0.00132561 120.264L15.8547 136.748L0.00132561 153.23L0.00132561 120.264Z"
        fill="#99DAA2"
      />
      <path
        d="M15.8544 103.781L31.7065 87.2974H0.00100327L15.8544 103.781Z"
        fill="#F6836C"
      />
      <path
        d="M31.707 120.263L15.8549 103.781L0.000209808 120.263H31.707Z"
        fill="#7264AB"
      />
      <path
        d="M31.707 120.263L31.707 87.2975L15.8549 103.781L31.707 120.263Z"
        fill="#F25746"
      />
      <path
        d="M0.00132561 87.2975L15.8547 103.781L0.00132561 120.263L0.00132561 87.2975Z"
        fill="#CCEFFC"
      />
      <path
        d="M15.8544 70.8142L31.7065 54.3321H0.00100327L15.8544 70.8142Z"
        fill="#F6836C"
      />
      <path
        d="M31.707 87.2965L15.8549 70.8144L0.000209808 87.2965H31.707Z"
        fill="#EF3120"
      />
      <path
        d="M31.707 87.2965L31.707 54.3309L15.8549 70.8144L31.707 87.2965Z"
        fill="#B3E6FA"
      />
      <path
        d="M0.00132561 54.3309L15.8547 70.8144L0.00132561 87.2965L0.00132561 54.3309Z"
        fill="#66C87F"
      />
      <path
        d="M15.8544 37.8455L31.7065 21.3634L0.00100327 21.3634L15.8544 37.8455Z"
        fill="#99DAA2"
      />
      <path
        d="M31.707 54.332L15.8549 37.8486L0.000209808 54.332H31.707Z"
        fill="#4E4699"
      />
      <path
        d="M31.707 54.332L31.707 21.3651L15.8549 37.8486L31.707 54.332Z"
        fill="#33B764"
      />
      <path
        d="M0.00132561 21.3665L15.8547 37.8499L0.00132561 54.332L0.00132561 21.3665Z"
        fill="#FBCCE8"
      />
      <path
        d="M15.8544 4.8833L31.7065 -11.6002L0.00100327 -11.6002L15.8544 4.8833Z"
        fill="#FBCCE8"
      />
      <path
        d="M31.707 21.3655L15.8549 4.88337L0.000209808 21.3655L31.707 21.3655Z"
        fill="#FBCCE8"
      />
      <path
        d="M31.707 21.3655L31.707 -11.6001L15.8549 4.88337L31.707 21.3655Z"
        fill="#2F3289"
      />
      <path
        d="M0.00132561 -11.6001L15.8547 4.88337L0.00132561 21.3655L0.00132561 -11.6001Z"
        fill="#F25746"
      />
      <path
        d="M15.8544 400.494L31.7065 384.011H0.00100327L15.8544 400.494Z"
        fill="#99DAA2"
      />
      <path
        d="M31.707 416.979L31.707 384.012L15.8549 400.496L31.707 416.979Z"
        fill="#CCEFFC"
      />
      <path
        d="M0.00132561 384.013L15.8547 400.496L0.00132561 416.979L0.00132561 384.013Z"
        fill="#F9B3DD"
      />
    </svg>
  );
};
